import React, {useState} from 'react';
import {BasicCandidateCard} from "./BasicCandidateCard";
import { Button } from 'react-bootstrap';
import { InviteCandidate } from '../Modals/InviteCandidate';
import { Candidate } from '../../types';

export function CandidateCardForManager({ candidate } : { candidate: Candidate }) {
    const [modalOpen, setModalOpen] = useState(false)

    const showModal = () => {
        setModalOpen(true)
    }

    const closeModal = () => {
        setModalOpen(false)
    }

    return (
        <BasicCandidateCard candidate={candidate} link={'/candidate/'+candidate.id}>
            <Button style={{height:'32px', padding: '5px 16px'}} onClick={showModal}> Пригласить </Button>
            <InviteCandidate isOpen={modalOpen} close={closeModal} profileId={candidate.id}/>
        </BasicCandidateCard>
    )
}